<style scoped>

</style>
<template>
  <div>
    <NoticeChannel />
    <RedDotChannel />
    <AsyncDataChannel />
  </div>
</template>
<script>
  import NoticeChannel from './notice_channel';
  import RedDotChannel from './red_dot_channel';
  import AsyncDataChannel from './async_data_channel';

  export default {
    components: { NoticeChannel, RedDotChannel, AsyncDataChannel }
  }
</script>
